var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "회사정보 관리",
      "topBtn": ""
    }
  }, [_c('template', {
    slot: "topBtn"
  }, [_c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'view',
      expression: "mode == 'view'"
    }],
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'form';
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 수정하기 ")])], 1), _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'form',
      expression: "mode == 'form'"
    }],
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function ($event) {
        _vm.mode = 'view';
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 취소하기 ")])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("개인정보")]), _c('company-baseinfo-form', _vm._b({
    staticClass: "mb-40 mb-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'company-baseinfo-form', {
    mode: _vm.mode
  }, false)), _c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("상세정보")]), _c('company-moreinfo-form', _vm._b({
    staticClass: "mb-40 mb-lg-60",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'company-moreinfo-form', {
    mode: _vm.mode
  }, false)), _c('h5', {
    staticClass: "page-text--lg mb-8 mb-lg-16 line-height-15"
  }, [_vm._v("소개정보")]), _c('company-metainfo-form', _vm._b({
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'company-metainfo-form', {
    mode: _vm.mode
  }, false)), _c('v-slide-y-reverse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.mode == 'form',
      expression: "mode == 'form'"
    }]
  }, [_c('v-card-actions', [_c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.reset
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("초기화")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v("저장하기")])])], 1)])], 1)])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }